export default "__VITE_ASSET__BCp$_NeG__"